import { css } from '@eti/styles';
import { vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const getMargin = (withDirection, isOverWing) => {
  if (isOverWing) {
    return withDirection ? '0' : '10px';
  }
  return withDirection ? '30px' : '10px';
};
const styles = (isEmptyRow, isLeft, isRight, isOverWing) => css`
  background-color: ${isEmptyRow ? 'transparent' : vars.colors.inputs.border};
  margin-left: ${getMargin(isLeft, isOverWing)};
  margin-right: ${getMargin(isRight, isOverWing)};
  width: 5px;
`;
const Wall = _ref => {
  let {
    isEmptyRow,
    isLeft,
    isOverWing,
    isRight
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles(isEmptyRow, isLeft, isRight, isOverWing),
    "data-testid": isLeft ? 'leftWall' : 'rightWall'
  });
};
export default Wall;
//# sourceMappingURL=Wall.js.map